import { Box, Grid, Modal, TextField, Typography } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";

import CloseIcon from "@mui/icons-material/Close";
import { useEffect, useState } from "react";
import UserCard from "./userCard";
import { getAllCustomerDetail, getLastDetail } from "./api";
import { searchedElementDisplay } from "./function";
const LastCustomer = ({
  searchModal,
  setSearchModal,
  callback,
  // userDetail,
}) => {
  const [collection, setCollection] = useState([]);
  const [searchCurrentModal, setSearchCurrentModal] = useState("");
  const getCounterSalesCusomter = async (param) => {
    // await getCounterSalesCustomers(param).then((res) => {
    //   console.log("countersales res data   ", res?.data?.data, " ", {
    //     page: res.data.pageNumber,
    //     total: res.data.totalPages,
    //   });
    //   setPagination({
    //     page: res.data.pageNumber,
    //     total: res.data.totalPages,
    //   });
    //   console.log("res?.data",res?.data?.data?.list)
    //   setUnPaidBill([...res?.data?.data?.list]);
    // });
  };

  useEffect(() => {
    console.log("dddd");
    if (searchModal === true) {
      getAllCustomerDetail(
        {
          //  mobile:"5454545454",
          page: 1,
          pageSize: 1000,
        },
        (data) => {
          setCollection(data);
          console.log("data detail ", data);
        }
      );
      //   getCounterSalesCusomter({
      //     filter: "",

      //     search: "",
      //     page: 1,
      //     pageSize: 1000,
      //   });
      //   setBillData({ ...billData, mybusinessId: userDetail?.myBusinessId });
    } else {
      console.log("close");
      //   setBillData(data);
      //   setUnPaidBillData();

      //   setSearchCurrentModal("")
    }
  }, [searchModal]);
  return (
    <Modal
      open={searchModal}
      sx={{ zIndex: 999999 }} // Yo
      onClose={() => {
        setSearchModal(false);
      }}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Grid
        container
        sx={{
          // backgroundColor: "white",
          // width:"40%"
          background: "white",
          width: { xs: "95%", sm: "50%", md: "45%", lg: "45%", xl: "45%" },

          height: "80vh",
          borderRadius: "10px",
          position: "absolute",
          left: { xs: "2%", sm: "25%", md: "28%", lg: "28%" },
          top: "10%",
        }}
      >
        <Grid item xs={12} sx={{ padding: "20px" }}>
          <Box
            sx={{
              height: "7vh",
              textAlign: "center",
              display: "flex",
              alignContent: "center",
              gap: 1,
            }}
          >
            <TextField
              sx={{
                flex: 1,
                fontSize: { xs: "12px", sm: "13px", md: "15px" },
              }}
              size="small"
              label="Search by Customer Name"
              value={searchCurrentModal}
              InputLabelProps={{
                // shrink: !!employeeDetail?.name,
                sx: {
                  // fontWeight: 500,
                  fontSize: { xs: "12px", sm: "13px", md: "15px" },
                },
              }}
              onChange={(e) => {
                // getPaymentRec(
                //   {
                //       "page": 1,
                //       "pageSize": 10,
                //       "filter": e.target.value,//"filter": null,
                //       "search": "",
                //       "date": null

                //   },
                //   getPaymentReceipt,
                //   setNumberOfRecords,
                //   setTotals,
                //   totals,
                //   setReceipts
                // );
                setSearchCurrentModal(e.target.value);
              }}
              InputProps={{
                sx: {
                  fontSize: { xs: "13px", sm: "13px", md: "15px" }, 
                  // fontFamily: "Montserrat", // optional
                },
                endAdornment: (
                  <SearchIcon
                    sx={{
                      color: (theme) => theme.palette.primary.main,
                    }}
                  />
                ),
              }}
            />
            <CloseIcon
              sx={{
                cursor: "pointer",
                fontSize: "27px",
                marginTop: "5px",
                color: (theme) => theme.palette.primary.main,
              }}
              onClick={() => setSearchModal(false)}
            />
          </Box>
          <Box sx={{ height: "calc(80vh - 7vh - 40px)", overflowY: "auto" }}>
            <Grid container>
              {collection.map((item, index) => {
                if (searchedElementDisplay(item, searchCurrentModal)) {
                  return null;
                }
                return (
                  <Grid
                    container
                    sx={{
                      marginRight: "10px",
                      marginBottom: "10px",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      backgroundColor: "#CACAFF",
                      borderRadius: "10px",
                      cursor: "pointer",
                    }}
                  >
                    <Grid
                      item
                      xs={8}
                      onClick={() => {
                        callback(item);
                      }}
                    >
                      {/* < UserCard
                      key={"employee" + index}
                      data={item}
                      callBack={() => {
                        callback(item)
                        // getUnpaid({
                        //   customerMobile: item?.mobile,
                        // });
                        // setBillData({
                        //   ...item,
                        //   customerMobile: item?.mobile,
                        //   customer: item?.name,
                        // // });
                        // setSearch(item?.name)
                        // setUSerObject(item)
                        // callSearchApi(item?.name)
                        // setSearchModal(false)
                      }}
                    /> */}
                      <Grid
                        container
                        sx={{
                          display: "flex",
                          justifyContent: "space-between",
                          paddingY: "10px",
                        }}
                      >
                        <Typography
                          component="span"
                          sx={{
                            fontSize: { xs: "13px", sm: "13px", md: "15px" }, 
                            fontWeight: 500,
                            fontFamily: "'Montserrat', sans-serif",
                          }}
                        >
                          {item?.name}
                        </Typography>
                        <Typography
                          component="span"
                          sx={{
                            fontSize: { xs: "13px", sm: "13px", md: "15px" }, 
                            fontWeight: 500,
                            fontFamily: "'Montserrat', sans-serif",
                          }}
                        >
                          {item?.customerMobile}
                        </Typography>
                      </Grid>
                    </Grid>
                  </Grid>
                );
              })}
            </Grid>
          </Box>
        </Grid>
      </Grid>
    </Modal>
  );
};

export default LastCustomer;
